import styled from 'styled-components';

interface ContainerProps {
  $navbar?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;

  ${({ $navbar }) =>
    $navbar &&
    `
        transform: translate(7rem, -5.3rem);
      `}

  .resumo-backdrop {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    position: absolute;

    @media (max-width: 768px) {
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    }
  }

  .resumo-modal {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    width: 420px;
    max-width: 100%;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);

    @media (max-width: 768px) {
      width: 100%;
      padding: 16px;
      border-radius: 10px;
    }
  }

  .resumo-title {
    font-weight: 700;
    margin-bottom: 12px;
    color: black !important;
  }

  .resumo-modal p {
    font-size: 14px;
    color: #444;
    line-height: 1.5;
  }

  #resumo-close {
    position: absolute;
    top: 14px;
    right: 14px;
    background: transparent !important;
    border: none;
    font-size: 18px;
    cursor: pointer;
    @media (max-width: 768px) {
      left: 95%;
      right: 0;
      margin-right: 1rem;
      top: 0;
      position: relative;
    }
  }
`;
